<!--
  - Copyright (c) 2021. Michael Clovis
  - This program is free software: you can redistribute it and/or modify
  -     it under the terms of the GNU Affero General Public License as published by
  -     the Free Software Foundation, either version 3 of the License, or
  -     (at your option) any later version.
  -
  -     This program is distributed in the hope that it will be useful,
  -     but WITHOUT ANY WARRANTY; without even the implied warranty of
  -     MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  -     GNU Affero General Public License for more details.
  -
  -     You should have received a copy of the GNU Affero General Public License
  -     along with this program.  If not, see <https://www.gnu.org/licenses/>.
  -->

<template>
  <tr>

    <td class="col-3">Totals:&nbsp;</td>
    <schedule-total-item :d-rota="rota.filter(elem=>{
        return elem.isOnSameDayAs(moment.clone().add(num,'days'));
      })" :show-pay="showPay" v-for="num in numbers" :key="num" :moment="moment.clone().add(num,'days')">

    </schedule-total-item>
    <schedule-total-column-item
        :show-pay="showPay"
        :rota="rota.filter((el)=>el.isBetween(moment.clone().add(numbers[0],'days').startOf('day'),
      moment.clone().add(numbers[numbers.length-1],'days').endOf('day')))">

    </schedule-total-column-item>
  </tr>
</template>

<script>
import ScheduleTotalItem from "./ScheduleTotalItem";
import ScheduleTotalColumnItem from "./ScheduleTotalColumnItem";

export default {
  name: "ScheduleTotalLine",
  components: {ScheduleTotalColumnItem, ScheduleTotalItem},
  data() {
    return {
      numbers: [],
    }
  },
  props: {
    moment: {
      type: Object,
      required: true
    },
    showPay: {
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.setNumbers();
  },
  watch: {
    moment: {
      deep: true,
      handler() {
        this.setNumbers();
      },

    }
  },
  computed: {
    rota() {
      return this.$store.state.appointments;
    }
  },
  methods: {
    setNumbers() {
      let startNum = 0;
      this.numbers = [];
      switch (this.moment.format("dd")) {
        case "Su":
          startNum = 0;
          break;
        case "Mo":
          startNum = -1;
          break;
        case "Tu":
          startNum = -2;
          break;
        case "We":
          startNum = -3;
          break;
        case "Th":
          startNum = -4;
          break;
        case "Fr":
          startNum = -5;
          break;
        case "Sa":
          startNum = -6;
          break;


      }// end switch
      let ctr = 0;
      while (ctr <= 6) {
        this.numbers.push(startNum + ctr);
        ctr++;
      }
    }
  },

}
</script>

<style scoped>

</style>
